import type dayjs from "dayjs";

import { getQueryParams } from "app/pages/industry-analysis/common/getQueryParams";

import { parseGrowthOverviewDate } from "./growthOverviewDateUtils";

export const getGrowthOverviewIntervalEndDate = (): dayjs.Dayjs | undefined => {
    const { to } = getQueryParams();
    return parseGrowthOverviewDate(to) ?? undefined;
};
